export const breakpoints = {
    L: 1366, //this or more than this is "desktop"
    M: 768,  //less than L but more than this "tablet"
    S: 375   //less than M but more than this "mobile"
}